import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Spinner, Form } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { getVehicleListById, updateVehicleData, saveVehicleData } from "../../redux/actions/VehicleActions";
import { getAllUsersRoleWiseList, getMasterVendorList } from "../../redux/actions/MasterActions";
import FormInput from "../../Components/FormInput";
import { useNavigate, useParams } from "react-router-dom";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import HyperDatepicker from "../../Components/Datepicker";
import { getDateTimeMysqlGivenFormatYmd } from '../../util/generalUtills'
import Preloader from "../../Components/Preloader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const Dashboard = () => {
  const { id } = useParams();
  const navigate = useNavigate();
    const [fieldErrors, setFieldErrors] = useState({});

    const [roleCode,setroleCode]=useState("JUNIOR_ENGINEER");
  
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    rc_expiry: new Date(),
    permit_expiry: new Date(),
    insurance_expiry: new Date(),
    fitness_expiry: new Date(),
  });
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    vehicleReducer: {
      loadingVehicle,
      errorsVehicle,
      vehicleLists,
      changedVehicleStatus,
    },
    masterReducer: {
      masterVendorLists,
      masterUsersRoleWiseLists,
      loadingMaster,
      errorsMaster,
    },
  } = useSelector((state) => state);

  

 useEffect(() => {
    if (auth?.accessToken && roleCode) {
      dispatch(getAllUsersRoleWiseList(auth?.accessToken, roleCode));
    }
  }, [auth?.accessToken, roleCode, dispatch]);



 useEffect(() => {
    if (auth?.accessToken) {
      dispatch(getMasterVendorList(auth?.accessToken, formData?.jenId || ""));
    }
  }, [auth?.accessToken, formData?.jenId, dispatch]);

  useEffect(() => {
    if (id) {
      dispatch(getVehicleListById(auth?.accessToken, id));
    }
  }, [auth, id]);

  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if (id) {
      dispatch(updateVehicleData(auth?.accessToken, formData, id));
    }
    else {
      dispatch(saveVehicleData(auth?.accessToken, formData));
    }
  };

  useEffect(() => {
    if (id) {
      if (vehicleLists && Object.keys(vehicleLists).length > 0) {
        setFormData({
          vehicleNumber: vehicleLists?.vehicleNumber,
          vehicleType: vehicleLists?.vehicleType,
          rcExpiry: vehicleLists?.rcExpiry,
          permitExpiry: vehicleLists?.permitExpiry,
          insuranceExpiry: vehicleLists?.insuranceExpiry,
          fitnessExpiry: vehicleLists?.fitnessExpiry,
          remark: vehicleLists?.remark,
          vendorId: vehicleLists?.vendor?.id,
          jenId: vehicleLists?.vendor?.jen?.id,
          status: vehicleLists?.status,
        });
      }
    }

  }, [vehicleLists])


  useEffect(() => {
    console.log("formData changed:", formData);
  }, [formData]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      if (errors?.status === 401) {
        dispatch(logout());
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  }, [errors, dispatch, navigate]);

  useEffect(() => {
    if (errorsVehicle && Object.keys(errorsVehicle).length > 0) {
      if (errorsVehicle?.status === 409) {
        swal.fire({
          show: true,
          title: "Oops!",
          text: errorsVehicle?.data?.message,
          icon: "error",
          showConfirmButton: false,
          timer: 1500
        });
        dispatch({ type: 'RESET_DELETE_VEHICLE_STATUS' });
      } else if (errorsVehicle?.status === 400) {
        // Handle other status
        if (errorsVehicle?.data?.errors && Array.isArray(errorsVehicle.data.errors)) {
          const transformedErrors = {};
          errorsVehicle.data.errors.forEach(error => {
            if (error.field && error.message) {
              transformedErrors[error.field] = error.message;
            }
          });
          setFieldErrors(transformedErrors);
        }
      } else {
        dispatch({ type: 'RESET_DELETE_VEHICLE_STATUS' });
      }
    }
  }, [errorsVehicle, dispatch]);

  useEffect(() => {
    if (changedVehicleStatus?.message) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedVehicleStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_VEHICLE_STATUS' });
      navigate(-1);
    }
  }, [changedVehicleStatus, dispatch, navigate]);

  // Reset formData and errorsVehicle when the component mounts
  useEffect(() => {
    setFormData({});
    dispatch({ type: 'RESET_DELETE_VEHICLE_STATUS' });
  }, [dispatch]);

  const inputHandler = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
    if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const inputHandlerCaps = (e) => {
    const { value, name } = e.target;
    const processedValue = value.replace(/\s+/g, '').toUpperCase(); // Remove spaces and convert to uppercase
    setFormData({ ...formData, [name]: processedValue });
    if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const selectHandler = (selectedData, name) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedData[0].value,
    }));
    if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const selectHandler2 = (selectedData, name) => {
    const selectedId = selectedData[0]?.vendorId;
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedId
    }));
    if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const inputDateHandler = (name, value) => {
    //const { value, name } = e.target;
    setFormData({ ...formData, [name]: getDateTimeMysqlGivenFormatYmd(value) });
    if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };


  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errorsVehicle?.data?.vehicleType ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: errorsVehicle?.data?.vehicleType ? 'red' : base.borderColor,
      }
    }),
  };

  const onDateChange = (name, value) => {
    if (value) {
      setFormData({ ...formData, [name]: getDateTimeMysqlGivenFormatYmd(value) });
    }
  };
useEffect(() => { 
    console.log('fieldErrors', fieldErrors);
  },[fieldErrors]);

  useEffect(()=>{
    setFieldErrors({})

  },[navigate]);
  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Vehicle"), path: "Vehicle" },
          { label: id ? t("Update Vehicle") : t("Add Vehicle"), path: "/Add-Vehicle", active: true },
        ]}
        title={id ? t("Update Vehicle") : t("Add Vehicle")}
      />
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Body>
              {errors?.data?.message && (
                <div className="alert alert-danger">
                  {errors.data.message}
                </div>
              )}
              <Row>
                <Col lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("J.E.N.")}</Form.Label>
                    <Select
                    className={fieldErrors?.jenId ? "border-danger" : ""}
                      options={masterUsersRoleWiseLists}
                      values={masterUsersRoleWiseLists?.filter(data => data.id === formData.jenId)}
                      name="jenId"
                      labelField={"name"}
                      valueField={"id"}
                      onChange={(selectedData) => {
                        setFormData(prevFormData => ({
                          ...prevFormData,
                          jenId: selectedData[0]?.id,
                          vendorId: "" // Reset vendor when JEN changes
                        }));
                      }}
                      styles={customSelectStyles}
                    />
                    {fieldErrors?.jenId && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.jenId}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Vendor")}</Form.Label>
                    <Select
                    className={fieldErrors?.vendorId ? "border-danger" : ""}
                      options={masterVendorLists}
                      values={masterVendorLists?.filter(name => name?.vendorId === formData.vendorId)}
                      name="vendorId"
                      labelField={"vendorName"}
                      valueField={"vendorId"}
                      searchBy="vendorName"
                      onChange={(selectedData) => {
                        setFormData(prevFormData => ({
                          ...prevFormData,
                          vendorId: selectedData[0]?.vendorId
                        }));
                      }}
                      styles={customSelectStyles}
                    />
                     {fieldErrors?.vendorId && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.vendorId}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>
                
                <Col lg={4}>
                  <FormInput
                    label={t("Vehicle Number")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.vehicleNumber}
                    name="vehicleNumber"
                    onChange={inputHandlerCaps}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Vehicle Type")}</Form.Label>

                     <Select

                      classNamePrefix="react-select"
                      name="vehicle_model"
                      defaultValue={formData?.vehicleType}
                      options={[
                        { value: "Tractor", label: "Tractor" },
                      ]}
                      values={[
                        { value: "Tractor", label: "Tractor" },
                      ]}
                      onChange={(selectedData) => selectHandler(selectedData, "vehicleType")}
                      styles={customSelectStyles}
                    />
                    {fieldErrors?.vehicleType && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.vehicleType}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>


                <Col lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("R.C. Expiry")}</Form.Label>
                    <DatePicker
                      selected={formData.rcExpiry}
                      onChange={(value) => inputDateHandler('rcExpiry', value)}
                      dateFormat="yyyy-MM-dd" // Display the date in yyyy-MM-dd format
                      maxDate={(() => {
                        const date = new Date();
                        date.setFullYear(date.getFullYear() + 5);  // Subtract 18 years
                        return date;
                      })()}
                      minDate={(() => {
                        const date = new Date();
                        date.setFullYear(date.getFullYear());  // Subtract 18 years
                        return date;
                      })()}
                      className="form-control"
                      withPortal
                      showYearDropdown
                      scrollableYearDropdown
                    />

                    {fieldErrors?.rcExpiry && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.rcExpiry}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Permid Expiry")}</Form.Label>
                    <DatePicker
                      selected={formData.permitExpiry}
                      onChange={(value) => inputDateHandler('permitExpiry', value)}
                      dateFormat="yyyy-MM-dd" // Display the date in yyyy-MM-dd format
                      maxDate={(() => {
                        const date = new Date();
                        date.setFullYear(date.getFullYear() + 5);  // Subtract 18 years
                        return date;
                      })()}
                      minDate={(() => {
                        const date = new Date();
                        date.setFullYear(date.getFullYear());  // Subtract 18 years
                        return date;
                      })()}
                      className="form-control"
                      withPortal
                      showYearDropdown
                      scrollableYearDropdown
                    />

                    {fieldErrors?.permitExpiry && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.permitExpiry}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Insurance Expiry")}</Form.Label>
                    <DatePicker
                      selected={formData.insuranceExpiry}
                      onChange={(value) => inputDateHandler('insuranceExpiry', value)}
                      dateFormat="yyyy-MM-dd" // Display the date in yyyy-MM-dd format
                      maxDate={(() => {
                        const date = new Date();
                        date.setFullYear(date.getFullYear() + 5);  // Subtract 18 years
                        return date;
                      })()}
                      minDate={(() => {
                        const date = new Date();
                        date.setFullYear(date.getFullYear());  // Subtract 18 years
                        return date;
                      })()}
                      className="form-control"
                      withPortal
                      showYearDropdown
                      scrollableYearDropdown
                    />

                    {fieldErrors?.insuranceExpiry && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.insuranceExpiry}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Fitness Expiry")}</Form.Label>
                    <DatePicker
                      selected={formData?.fitnessExpiry}
                      onChange={(value) => inputDateHandler('fitnessExpiry', value)}
                      dateFormat="yyyy-MM-dd" // Display the date in yyyy-MM-dd format
                      maxDate={(() => {
                        const date = new Date();
                        date.setFullYear(date.getFullYear() + 5);  // Subtract 18 years
                        return date;
                      })()}
                      minDate={(() => {
                        const date = new Date();
                        date.setFullYear(date.getFullYear());  // Subtract 18 years
                        return date;
                      })()}
                      className="form-control"
                      withPortal
                      showYearDropdown
                      scrollableYearDropdown
                    />

                    {fieldErrors?.fitnessExpiry && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.fitnessExpiry}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>



                <Col lg={4}>
                  <FormInput
                    label={t("Remark")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.remark}
                    name="remark"
                    onChange={inputHandlerCaps}
                    containerClass={"mb-3"}
                  />
                </Col>
              </Row>

              <div className="d-flex justify-content-center">
                {loading ?
                  <Button color="primary" disabled>
                    <Spinner
                      className="spinner-border-sm me-1"
                      tag="span"
                      color="white"
                    />
                    Please wait ...
                  </Button>
                  :
                  <Button type="button" onClick={handleSubmit} disabled={loading}>
                    Submit
                  </Button>
                }
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loadingMaster && (<Preloader />)}
      {loadingVehicle && (<Preloader />)}
    </>
  );
};

export default Dashboard;
